var m = require('mithril');
var moment = require('moment-timezone');
var loaders = require('../../layout/components/loaders');
var Model = require('../../libs/Model');
var formGroup = require('../../components/formGroup');
var headingElement = require('../../components/heading');
var verticalListItem = require('../../components/verticalListItem');
var selectInput = require('../../components/inputs/selectInput');
var Point = require('../../data/models/point');

var rruleModel = Object.create(Model);

var weekDayAbbreviations = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
var monthAbbreviations = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

rruleModel.name = 'event';
// rruleModel.url = 'event';
rruleModel['@class'] = 'event';
rruleModel.fields = {
  dtstart: {
    default: moment(),
    type: 'date'
  },
  until: {
    type: 'date',
    default: null
  },
  freq: {
    default: 'never'
  },
  interval: {
    type: 'number',
    default: 1
  },
  byweekday: {
    default: null
  },
  bymonth: {
    default: null
  },
  bymonthday: {
    default: null
  }
};

rruleModel.oninit = function () {
  var ctrl = this;

  ctrl.toggleDayOfWeek = function toggleHour (day) {
    if (!Array.isArray(rruleModel.form.byweekday())) {
      rruleModel.form.byweekday([]);
    }
    var found = rruleModel.form.byweekday().findIndex(function (el) {
      return el == day
    });

    if (found > -1) {
      rruleModel.form.byweekday().splice(found, 1);
    } else {
      rruleModel.form.byweekday().push(day);
    }

    if (rruleModel.form.byweekday().length == 0) {
      rruleModel.form.byweekday(null)
    }
  }

  ctrl.toggleDayOfMonth = function toggleDay (day) {
    if (!Array.isArray(rruleModel.form.bymonthday())) {
      rruleModel.form.bymonthday([]);
    }

    var found = rruleModel.form.bymonthday().findIndex(function (el) {
      return el == day
    });

    if (found > -1) {
      rruleModel.form.bymonthday().splice(found, 1);
    } else {
      rruleModel.form.bymonthday().push(day);
    }

    if (rruleModel.form.bymonthday().length == 0) {
      rruleModel.form.bymonthday(null)
    }
  }

  ctrl.toggleMonthOfYear = function toggleMonth (day) {
    if (rruleModel.form.bymonth().length == 0) {
      rruleModel.form.bymonth(null)
    }

    var found = rruleModel.form.bymonth().findIndex(function (el) {
      return el == day
    });

    if (found > -1) {
      rruleModel.form.bymonth().splice(found, 1);
    } else {
      rruleModel.form.bymonth().push(day);
    }


    if (rruleModel.form.bymonth().length == 0) {
      rruleModel.form.bymonth(null)
    }
  }
}

rruleModel.view = function view () {
  var ctrl = this;
  return m('div', [

    m('div', [
      m('label', 'Repeat'),
      m('select' , {value: rruleModel.form.freq(), onchange: function(ev){rruleModel.form.freq(ev.target.value)}}, [
        m('option', {value: 'never'}, 'Never'),
        m('option', {value: 'daily'}, 'Daily'),
        m('option', {value: 'weekly'}, 'Weekly'),
        m('option', {value: 'monthly'}, 'Monthly'),
        m('option', {value: 'yearly'}, 'Yearly')
      ])
    ]),
    (function () {
      if (rruleModel.form.freq() == 'daily') {
        return m('div.flex.items-center.pt2', [
          m('label', 'Every'),
          m('input.mh2.mv2', {
            style: {width: '3em'},
            type: 'number',
            class: 'form-control',
            oninput: function(ev){rruleModel.form.interval(ev.target.value)},
            placeholder: rruleModel.form.interval(),
          }),
          m('span', 'Day(s)')
        ])
      } else if (rruleModel.form.freq() == 'weekly') {
        return m('div', [
          m('div.flex.items-center.pt2', [
            m('label', 'Every'),
            m('input.mh2.mv2', {
              style: {width: '3em'},
              type: 'number',
              class: 'form-control',
              oninput: function(ev){rruleModel.form.interval(ev.target.value)},
              placeholder: rruleModel.form.interval(),
            }),
            m('span', 'Week(s) on...'),
          ]),
          m('div.flex.flex-wrap', [...Array(7).keys()].map(function (e, idx) {
            return m('div.dt.pv1.mr1.w3', [
              m('div.dtc.v-mid.tc.ba.bw1.pa3.' + ((rruleModel.form.byweekday() || []).find(function (el) { return el == idx }) > -1 ? 'bg-blue' : ''), 
                {
                  onclick: ctrl.toggleDayOfWeek.bind(ctrl, idx),
                },
                weekDayAbbreviations[idx]
              )
            ])
          }))
        ])
      } else if (rruleModel.form.freq() == 'monthly') {
        return m('div', [
          m('div.flex.items-center.pt2', [
            m('label', 'Every'),
            m('input.mh2.mv2', {
              style: {width: '3em'},
              type: 'number',
              class: 'form-control',
              oninput: function(ev){rruleModel.form.interval(ev.target.value)},
              placeholder: rruleModel.form.interval(),
            }),
            m('span', 'Months(s) on...'),
          ]),
          m('div.flex.flex-wrap', [...Array(31).keys()].map(function (e, idx) {
            return m('div.dt.pv1.mr1.w3', [
              m('div.dtc.v-mid.tc.ba.bw1.pa3.' + ((rruleModel.form.bymonthday() || []).find(function (el) { return el == idx }) > -1 ? 'bg-blue' : ''), 
                {
                  onclick: ctrl.toggleDayOfMonth.bind(ctrl, idx),
                },
                idx + 1
              )
            ])
          }))
        ])
      } else if (rruleModel.form.freq() == 'yearly') {
        return m('div', [
          m('div.flex.items-center.pt2', [
            m('label', 'Every'),
            m('input.mh2.mv2', {
              style: {width: '3em'},
              type: 'number',
              class: 'form-control',
              oninput: function(ev){rruleModel.form.interval(ev.target.value)},
              placeholder: rruleModel.form.interval(),
            }),
            m('span', 'Year(s)'),
          ]),
          m('div.flex.flex-wrap', [...Array(12).keys()].map(function (e, idx) {
            return m('div.dt.pv1.mr1.w3', [
              m('div.dtc.v-mid.tc.ba.bw1.pa3.' + ((rruleModel.form.bymonthday()  || []).find(function (el) { return el == idx }) > -1 ? 'bg-blue' : ''), 
                {
                  onclick: ctrl.toggleMonthOfYear.bind(ctrl, idx),
                },
                monthAbbreviations[idx]
              )
            ])
          }))
        ])
      }
    })()
  ])
}


module.exports = rruleModel;
